module.exports = __webpack_public_path__ + "img/address_list.2091ba7d.svg";